import { TransactionsTab as Component } from './component';
import Connector from './connector';

export const TransactionsTab = () => <Connector component={Component} />;
